import axios from "./userInstance"
export default async (userId: string) => {
  const response = await axios(`/users/${userId}/roles`)
  return response.data
}
